import { styled, Avatar, Chip, Stack, Typography } from '@mui/material';

interface UnitsFilterOption {
  label: string;
  value: string;
  icon?: string;
}

interface UnitsFilterProps {
  title: string;
  options: UnitsFilterOption[];
  value: string[];
  onChange: (value: string[]) => void;
}

const UnitsFilterOptionAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  backgroundColor: theme.palette.background.active,
}));

export default function UnitsFilter({ title, options, value, onChange }: UnitsFilterProps) {
  const handleSelect = (val: string) => {
    if (value.includes(val)) {
      return onChange(value.filter((r) => r !== val));
    }
    return onChange([...value, val]);
  };

  return (
    <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} useFlexGap flexWrap="wrap">
      <Typography variant="inputLabel" color="text.disabled">
        {title}:
      </Typography>
      {options.map((o) => (
        <Chip
          key={o.value}
          label={o.label}
          avatar={o.icon ? <UnitsFilterOptionAvatar alt={o.label} src={o.icon} /> : undefined}
          size="small"
          clickable
          color={value.includes(o.value) ? 'warning' : 'default'}
          onClick={() => handleSelect(o.value)}
        />
      ))}
    </Stack>
  );
}
